import SDUBanner from 'components/ShopYourStore/SDUBanner/SDUBanner';
import { withSDUBannerProps } from 'components/ShopYourStore/SDUBanner/withSDUBannerProps';

export default withSDUBannerProps(SDUBanner);
